import { createStyles, makeStyles } from '@material-ui/core/styles';
import { variables } from '../../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    dialog: {
      maxWidth: 'inherit',
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
    dialogTitle: {
      margin: 0,
      paddingLeft: 3,
      paddingRight: 0,
      gap: 16,
      paddingTop: 16,
      paddingBottom: 16,
      color: variables.richBlack,
    },
    closeBtn: {
      color: variables.richBlack,
    },
    root: {
      marginTop: 20,
      flexGrow: 1,
      maxWidth: 836,
    },
  }),
);
